import { Injectable } from '@angular/core';
import { Selector, State, StateContext, Action } from '@ngxs/store';
import { GlobalClaimCapReps } from 'app/models/dto/lead-assignment/global-claim-cap-reps.model';
import { GlobalClaimCap } from 'app/models/dto/lead-assignment/global-claim-cap.model';
import { GlobalClaimCapDataService } from 'app/services/lead-assignment/global-claim-cap.service';
import { tap } from 'rxjs/operators';
import { GetGlobalClaimCapData, SetGlobalClaimCapReps } from './global-claim-cap.actions';

export interface GlobalClaimCapsDataStateModel {
  globalClaimCapData: GlobalClaimCap;
}

@State<GlobalClaimCapsDataStateModel>({
  name: 'globalClaimCapsData',
  defaults: {
    globalClaimCapData: {
      reps: [],
      totals: {
        totalClaimedToday: 0,
        totalClaimedYesterday: 0,
        totalBucketsAssigned: 0,
        }
    }
  }
})

@Injectable()

export class GlobalClaimCapDataState {

  @Selector()
  static globalClaimCap(state: GlobalClaimCapsDataStateModel) {
    return state.globalClaimCapData;
  }

  @Selector()
  static currentTotalCap(state: GlobalClaimCapsDataStateModel) {
    let currentTotalCap = 0;
    let allRepsCapsCounted = true;

    state.globalClaimCapData.reps.forEach((rep: GlobalClaimCapReps) => {
      currentTotalCap += rep.globalClaimCap - rep.claimedToday;
    });

    if (currentTotalCap !== 0) {
      allRepsCapsCounted = false;
    }

    return { total: currentTotalCap, loaded: allRepsCapsCounted };
  }

  constructor(private globalClaimCapDataService: GlobalClaimCapDataService) { }

  @Action(GetGlobalClaimCapData)
  getLeadAssignmentGroups({ patchState }: StateContext<GlobalClaimCapsDataStateModel>, { }: GlobalClaimCapsDataStateModel) {
    return this.globalClaimCapDataService.getGlobalClaimCapData().pipe(tap(globalClaimCapData => {
      patchState({ globalClaimCapData });
    }));
  }

  @Action(SetGlobalClaimCapReps)
  setLeadAssignmentGroups({ patchState }: StateContext<GlobalClaimCapsDataStateModel>, { reps }: SetGlobalClaimCapReps) {
    return this.globalClaimCapDataService.SetGlobalClaimCapReps(reps).pipe(tap(globalClaimCapData => {
      patchState({ globalClaimCapData });
    }));
  }
}
